import project from 'data/project.json';

export const config = {
  locale: project._languages[0] || 'pl',
  tableTiles: true,
  investmentName: process.env.REACT_APP_INVESTMENT_NAME,
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  isMapHidden: false,
  phone: '+48 123 123 123',
};
